import * as zod from 'zod';

import { RobotiqBaseStateSchema } from '../../shared/types';

export const Robotiq2FState = RobotiqBaseStateSchema.extend({
  kind: zod.literal('Robotiq2F'),
  modelVariant: zod.string().optional(),
  gripWidth: zod.number().nonnegative(),
});

export type Robotiq2FState = zod.infer<typeof Robotiq2FState>;
